<template>
  <div
    v-if="hasAccount && isAdmin"
    id="admin-bar"
    class="app-admin-bar inverted with-border-bottom padding-top-xs"
    style="
      --hr-border-color: var(--fa-dk-navy);
      --hr-border-width: var(--border-width-md);
      --balloon-color: var(--fa-dk-blue);
      --link-color: var(--fa-gravy);
      --link-hover-color: var(--fa-blue);
    "
  >
    <div class="container">
      <div class="row roomy align-middle">
        <div class="column">
          <h1
            class="h5 display-flex flex-items-center margin-0"
            style="gap: var(--spacing-sm)"
          >
            <font-awesome-icon
              :icon="$v7.solid.faCog"
              class="muted"
              size="lg"
              fixed-with
              spin
            />
            <span
              ><span class="display-none tablet:display-inline">Welcome,</span> Admin<span class="display-none tablet:display-inline"
                >istrator of Awesome!</span
              ></span
            >
          </h1>
        </div>

        <div class="column text-right">
          <ul
            class="display-flex flex-items-center flex-content-end margin-0"
            style="
              gap: var(--spacing-sm);
              --list-margin-top: 0;
              --link-decoration-line: none;
              --link-decoration-line: none;
              --link-hover-decoration-line: none;
              --list-style-type: none;
            "
          >
            <li class="margin-0">
              <site-link
                :to="{ name: 'admin.dashboard' }"
                :class="adminActiveClass('admin.dashboard')"
                aria-label="Aye Aye, Admin-ral"
                data-balloon-pos="down"
                style="gap: var(--spacing-2xs)"
              >
                <font-awesome-icon
                  :icon="$v7.solid.faClipboard"
                  size="lg"
                />
                <span class="display-none laptop:display-inline">Admin</span>
              </site-link>
            </li>
            <li class="margin-0">
              <a
                href="/admin/system/dashboard"
                class="display-inline-flex flex-items-center padding-x-md padding-y-xs"
                aria-label="Check on the Warp Core"
                active-class="active"
                data-balloon-pos="down"
                style="gap: var(--spacing-2xs)"
              >
                <font-awesome-icon
                  :icon="$v7.solid.faGauge"
                  size="lg"
                />
                <span class="display-none laptop:display-inline">System</span>
              </a>
            </li>
            <li class="margin-0">
              <site-link
                :to="{ name: 'admin.reports' }"
                :class="adminActiveClass('admin.reports')"
                aria-label="Become Lord Business"
                data-balloon-pos="down"
                style="gap: var(--spacing-2xs)"
              >
                <font-awesome-icon
                  :icon="$v7.solid.faChartBar"
                  size="lg"
                />
                <span class="display-none laptop:display-inline">Reports</span>
              </site-link>
            </li>
            <li class="margin-0">
              <a
                href="/admin/oban"
                class="display-inline-flex flex-items-center padding-x-md padding-y-xs"
                aria-label="You Will Be A Time Lord"
                active-class="active"
                data-balloon-pos="down"
                style="gap: var(--spacing-2xs)"
              >
                <font-awesome-icon
                  :icon="$v7.solid.faGauge"
                  size="lg"
                />
                <span class="display-none laptop:display-inline">Oban</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AdminBar',

    computed: {
      hasAccount() {
        return !!this.$account
      },

      isAdmin() {
        return this.hasAccount && this.$account.admin
      }
    },

    methods: {
      adminActiveClass(routeName) {
        let activeClass

        if (routeName === 'admin.reports') {
          activeClass = 'admin.reports'
        }

        if (
          routeName === 'admin.dashboard' &&
          (this.$route.name === 'admin.dashboard' ||
            this.$route.name === 'admin.accounts' ||
            this.$route.name === 'admin.kits' ||
            this.$route.name === 'admin.affiliates' ||
            this.$route.name === 'admin.licenses' ||
            this.$route.name === 'admin.subscriptions')
        ) {
          activeClass = this.$route.name
        }

        return ['display-inline-flex flex-items-center padding-x-md padding-y-xs', { active: this.$route.name === activeClass }]
      }
    }
  }
</script>
